import { Button } from "react-bootstrap";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { useDispatch } from "react-redux";
import { IoReceipt } from "react-icons/io5";
import HelperService from "../../../utility/HelperService";
import { connect, useSelector } from "react-redux";
import { bookingEditPageRequest, bookingRequest, bookingDeleteDecline, bookingDeleteRequest, bookingAddOrEditRequest, bookingProjectOptionsRequest, } from "../BookingsAction";
import { bookingAddOrEditRequestPayload, BookingInterface, BookingState } from "../BookingTypes";
import { permissionsInterface, reduxInitialState } from "../../onBoarding/onBoardingTypes";
import { navigationRequest } from "../../../Navigation/NavigationRedux/NavigationRedux";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WebService from "../../../utility/WebService";
import { toast } from "react-toastify";
import { FaUpload } from "react-icons/fa";
import { PiExport } from "react-icons/pi";

const defaultHeaders: GridHeader[] = [
  {
    title: "Booking ID",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "book_id",
  },
  {
    title: "Booking Date",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Project name",
    class: "text-left",
  },
  {
    title: "Customer name",
    class: "text-left",
  },
  {
    title: "Unit",
    class: "text-left",
  },
  {
    title: "Owner",
    class: "text-left",
  },
  {
    title: "Total sq. ft.",
    class: "text-left",
  },
  {
    title: "Booking Value",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "total_cost",
  },
  {
    title: "Net Received",
    class: "text-left",
  },
  {
    title: "Total Due",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const cancelledHeaders: GridHeader[] = [
  {
    title: "Booking ID",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "book_id",
  },
  {
    title: "Booking Date",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Project name",
    class: "text-left",
  },
  {
    title: "Customer name",
    class: "text-left",
  },
  {
    title: "Unit",
    class: "text-left",
  },
  {
    title: "Owner",
    class: "text-left",
  },
  {
    title: "Total sq. ft.",
    class: "text-left",
  },
  {
    title: "Amount received",
    class: "text-left",
  },
  {
    title: "Net returned",
    class: "text-left",
  },
  {
    title: "Total Due to return",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const bookingOptions: any[] = [
  { value: "ACTIVE", label: "Active" },
  { value: "CANCELLED", label: "Cancelled" },
];

interface propData {
  getBookings: (params: any) => void;
  onNavigate: (path: string) => void;
  editBooking: (data: BookingInterface) => void;
  onDeleteBooking: () => void;
  onCreateOrEditBooking: (data: bookingAddOrEditRequestPayload) => void;
  getProjectOptions: (params: string) => void;
};

const Bookings = (props: propData) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bookingData: BookingState = useSelector((state: reduxInitialState) => state.BookingReducer);
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [isCancelled, setIsCancelled] = useState<boolean>(false);
  const [headers, setHeaders] = useState<GridHeader[]>(defaultHeaders);
  const searchParams = new URLSearchParams(window.location.search);
  const status = searchParams.get("status");
  const [startDate, setStartDate] = useState<Date | any>("");
  const [endDate, setEndDate] = useState<Date | any>("");
  const [keyword, setKeyword] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>(status ? status : "ACTIVE");
  const [projectId, setProjectId] = useState<string>("");


  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "BOOKINGS"));
    }
  }, [token])

  useEffect(() => { props.getProjectOptions(""); }, []);

  useEffect(() => { showHiddenFields && props.getBookings({ page: 1, is_session: true }); }, [showHiddenFields]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  const getProjectList = async (
    page: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    projectId?: string,
    selectedExpenseType?: string,
    status?: string,
    order_by?: string,
    sort_by?: string
  ) => {
    if (!bookingData.loading) {
      if (status == "CANCELLED") {
        setIsCancelled(true);
        setHeaders(cancelledHeaders)
      } else {
        setIsCancelled(false);
        setHeaders(defaultHeaders);
      }
      props.getBookings({
        page: page,
        keyword: keyword,
        fromDate: startDate,
        toDate: endDate,
        project_id: projectId ? projectId : "",
        status: status ? status : "",
        sort_by: order_by ?? "asc",
        order_by: sort_by ?? "created_at",
        is_session: showHiddenFields
      });
      setStartDate(startDate ?? "");
      setEndDate(endDate ?? "");
      setKeyword(keyword ?? "");
      setProjectId(projectId ?? "");
      setStatusFilter(status ?? "ACTIVE");
    }
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getProjectList(
      offset,
      "",
      null as any,
      null as any,
      null as any,
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    );
  };

  const getFormatedProjectRow = (list: BookingInterface[]) => {
    let rows: GridRow[] = [];
    for (var i in list) {
      let columns: GridColumn[] = [];
      const totalPaid: number = Number(list[i].paid_amount) - Number(list[i].amount_return_to_customer || "0");
      const total_due: number = totalPaid ? Number(list[i].total_cost) - Number(totalPaid) : Number(list[i].total_cost);
      columns.push({ value: list[i].book_id ? list[i].book_id : "N/A" });
      columns.push({ value: list[i].created_at && HelperService.getFormatedDate(list[i].created_at) });
      columns.push({ value: list[i].project ? list[i].project?.project_name : "N/A" });
      columns.push({ value: list[i].customer_name ? list[i].customer_name : "N/A" });
      columns.push({ value: list[i].project_units ? list[i].project_units.length ? list[i].project_units.map((unit: any) => unit.unit_name).join(", ") : "N/A" : "N/A" });
      columns.push({ value: list[i].project_units ? list[i].project_units.length ? list[i].project_units.map((unit: any) => unit.registration_power).join(", ") : "N/A" : "N/A" });
      columns.push({ value: list[i].project_units ? list[i].project_units.length ? Number(list[i].project_units.reduce((acc: number, unit: any) => acc + unit.area, 0)).toFixed(2) : "N/A" : "N/A" });
      if (isCancelled) {
        columns.push({ value: list[i].paid_amount ? HelperService.getCurrencyFormatter(list[i].paid_amount) : "N/A" });
        columns.push({ value: list[i].amount_return_to_customer ? HelperService.getCurrencyFormatter(list[i].amount_return_to_customer) : "N/A" });
        columns.push({ value: (list[i].paid_amount && list[i].amount_return_to_customer) ? HelperService.getCurrencyFormatter(Number(list[i].paid_amount) - Number(list[i].amount_return_to_customer || "0")) : "N/A" });
      } else {
        columns.push({ value: list[i].total_cost ? HelperService.getCurrencyFormatter(list[i].total_cost) : "N/A" });
        columns.push({ value: totalPaid ? HelperService.getCurrencyFormatter(totalPaid) : "N/A" });
        columns.push({ value: total_due ? HelperService.getCurrencyFormatter(total_due) : "N/A" });
      }
      columns.push({ value: ViewDetail(list[i], total_due), classname: (!list[i].is_registration_complete && list[i].is_payment_received) ? "bg-booking-registration" : '' });
      rows.push({ data: columns, classname: (!list[i].is_registration_complete && list[i].is_payment_received) ? "bg-booking-registration" : '' });
    }
    return rows;
  };

  const ViewDetail = (data: BookingInterface, total_due: number) => {
    return (
      <span className="action-btns">
        <>
          {permissions && permissions.can_update && <button
            onClick={() => {
              props.onCreateOrEditBooking({ data: data, isEdit: true });
              navigate(routePaths.BOOKING_UPDATE.path, {
                state: { type: showHiddenFields ? "REAL" : "FAKE" }
              });
            }}
            className="cursor-pointer  btn-edit btn"
          >
            {" "}
            <Pencil />{" "}
          </button>}
          <button className="cursor-pointer  btn-edit btn" onClick={() => props.onNavigate(routePaths.RECEIPT.path + "?booking=" + data.uuid)}>   {" "}  <IoReceipt />{" "} </button>
          <Button className="btn btn-secondary" onClick={() => navigate(routePaths.RECEIPT_CREATE.path + "/" + data.uuid)}>   {" "}<Plus size={20} className="ms-1" /> Add Receipt  </Button>

          <button className="cursor-pointer  btn-edit btn" onClick={() => props.onNavigate(routePaths.CUSTOMER_VOUCHER.path + data.uuid)}>   {" "}  <IoReceipt />{" "} </button>
          <Button className="btn btn-secondary" onClick={() => navigate(routePaths.CUSTOMER_VOUCHER_CREATE.path + "/" + data.uuid)}>   {" "}<Plus size={20} className="ms-1" /> Add Voucher  </Button>
        </>
      </span >
    );
  };

  const handleKeyDown = (e: any) => {
    const key = e.key.toLowerCase();
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key.toLowerCase();
    // Check for ctrl+p+t
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
      setShowHiddenFields(true);
    }

    // Remove the key from the set
    setPressedKeys((prev: any) => {
      const updated = new Set(prev);
      updated.delete(key);
      return updated;
    });
  };

  const uploadXlsxFile = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    WebService.fileUploadAPI({ action: 'upload/receipt/file/xls', file: file, key: 'file', is_session: showHiddenFields })
      .then((response: any) => {
        toast.success(response.message || "File uploaded successfully");
        getProjectList(1);
      }).catch((error: any) => { toast.error(error.message || "Failed to upload file"); });
  };

  const exportBookings = (isAll?: boolean) => {
    WebService.getAPI({
      action: `booking/export?keyword=${keyword ? keyword : ""}&fromDate=${startDate ? startDate : ""}&toDate=${endDate ? endDate : ""}&project_id=${projectId ? projectId : ""}&status=${statusFilter ? statusFilter : ""}&is_all=${isAll ? "true" : "false"}`,
      body: null,
      is_session: showHiddenFields,
      responseType: 'arraybuffer',
    }).then((response: any) => {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bookings_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }).catch((e) => {
      toast.error("Failed to export bookings");
    });
  };

  return (
    <>
      <DeleteModal
        isShow={bookingData.showDeleteModal}
        close={() => {
          dispatch(bookingDeleteDecline());
        }}
        onDelete={() => {
          props.onDeleteBooking();
        }}
      />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Bookings" backArrow={false} active={showHiddenFields} />
          <div className="d-flex justify-content-between align-items-center mb-3">
            {permissions && permissions.can_write && <Button
              className="btn btn-brand-1"
              onClick={() => {
                props.onNavigate(routePaths.BOOKING_CREATE.path);
              }}
            >
              {" "}
              <Plus size={20} className="ms-1" /> Add Booking
            </Button>}
            <Button className="btn btn-secondary ms-1" onClick={() => document.getElementById('fileInput')?.click()}>   {" "} <FaUpload /> Upload Receipts   </Button>
            <input type="file" id="fileInput" style={{ display: 'none' }} accept=".xlsx, .xls" onChange={(e) => {
              const file = e.target.files ? e.target.files[0] : null;
              if (file) {
                uploadXlsxFile(file);
              }
            }} />
            {permissions && permissions.can_write && permissions.can_update && <Button
              className="btn btn-brand-1 ms-2"
              onClick={() => { exportBookings(); }}
            >
              <PiExport size={20} className="ms-1" /> Export 80% Payment Bookings
            </Button>}
            {permissions && permissions.can_write && permissions.can_update && <Button
              className="btn btn-brand-1 ms-2"
              onClick={() => { exportBookings(true); }}
            >
              <PiExport size={20} className="ms-1" /> Export Bookings
            </Button>}
          </div>
        </div>
        <div className="table-card">
          {bookingData && (
            <Grid
              rows={getFormatedProjectRow(bookingData.bookingList)}
              showSearch={true}
              headers={headers}
              showDateFilter={true}
              ShowLoader={bookingData.loading}
              count={bookingData.listCount}
              onPageChange={getProjectList}
              errorMessage={"No Bookings Found"}
              projectOptions={bookingData?.projectOptions}
              isShowBookingFilter
              bookingOptions={bookingOptions}
              status={status ? status : "ACTIVE"}
              isShowProjectFilter
              onSort={onSortList}
            />
          )}
          <div>
            <div className="d-flex justify-content-end gap-5 mt-3 font-18 font-medium px-2">
              <div className="d-flex align-items-center gap-2">
                <span>Total Booked Area :-</span>
                <span className="fw-500">{HelperService.getCurrencyFormatter(bookingData.totalBookedArea)}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span>Total Booking Value :-</span>
                <span className="fw-500">{HelperService.getCurrencyFormatter(bookingData.totalBookingValue)}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span>Total Received Amount  :-</span>
                <span className="fw-500">{HelperService.getCurrencyFormatter(bookingData.totalRecivedAmount)}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span>Total Remaining Amount  :-</span>
                <span className="fw-500">{HelperService.getCurrencyFormatter(bookingData.totalBookingValue - bookingData.totalRecivedAmount)}</span>
              </div>
            </div>
          </div>
        </div>

      </div>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  getBookings: (params: any) => dispatch(bookingRequest(params)),
  onNavigate: (path: string) => dispatch(navigationRequest(path)),
  editBooking: (data: BookingInterface) =>
    dispatch(bookingEditPageRequest(data)),
  onDeleteBooking: () => dispatch(bookingDeleteRequest()),
  getProjectOptions: (params: string) =>
    dispatch(bookingProjectOptionsRequest(params)),
  onCreateOrEditBooking: (data: bookingAddOrEditRequestPayload) =>
    dispatch(bookingAddOrEditRequest(data)),
});

export default connect(null, mapDispatchToProps)(Bookings);
